export default __webpack_public_path__ + "static/media/animation.2ea24cb8.mp4";